import { ReactComponent as FlagIcon } from "./svg/fr-flag.svg";
import "../flag-icon.scss";

export const FRFlag = () => {
  return (
    <span className="flag-icon">
      <FlagIcon />
    </span>
  );
};
